import "./SeeOrder.css";
import { useState, useEffect } from "react";
import Axios from "axios";
import React from "react";
import Table from "react-bootstrap/Table";
import swal from "sweetalert";

function SeeOrder() {
  const [data, setData] = useState([]);
  const [ApprovalDate, setApprovalDate] = useState();
  const [approved, setapproved] = useState();
 const [searchInput, setSearchInput] = useState("");
  const [approvedOrderValue, setapprovedOrderValue] = useState();

  useEffect(() => {
    Axios.get("http://13.200.156.92:5000/getOrder").then((response) => {
      setData(response.data);
    });
  }, []);

  const giveDate = (id, approvedquantity, approvedvalue) => {
    if (approved === undefined) {
      swal({
        title: "Please enter Approved Quantity",
        text: "",
        icon: "warning",
      });
      return;
    }

    if (!ApprovalDate) {
      swal({
        title: "Please select Date",
        text: "",
        icon: "warning",
      });
      return;
    }

    console.log(approved);
    Axios.put("http://13.200.156.92:5000/ApprovePO", {
      id: id,
      ApprovalDate: ApprovalDate,
      updatedQuantity: approved,
      approvedOrderValue: approvedOrderValue,
    })
      .then(console.log(approvedquantity))
      .catch((err) => console.log(err));
    swal({
      title: "Order Approved",
      text: "",
      icon: "success",
    }).then(() => {
      window.location.reload();
    });
  };

   const filteredData = data.filter((row) => {
    const orderSkuMatch =
      row.orderid.toString().includes(searchInput) ||
      row.list.some((item) => item.sku.includes(searchInput));
    return orderSkuMatch;
  });

  return (
    <div className="ApprovePO">
      <h4 className="approveheading">Orders from Pinnacle </h4> 
        <input
        className="approvesearch1"
          type="text"
          placeholder="Search by Order ID or SKU"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />      
      <br />
      <div className="approvecontainer">
        <div className="approvecontent">
          <Table className="krin">
            <thead>
              <tr>
                <th>OrderID</th>
                <th>SKU</th>
                <th>Image</th>
                <th>Title</th>
                <th>Medium</th>
                <th>Quantity</th>             
                <th>Purchase_price</th>
                <th>Total</th>
                <th>Order-Date</th>           
              </tr>
            </thead>
           
          </Table>
        </div>
      </div>
    </div>
  );
}

export default SeeOrder;
